import {TFunction, type FlatNamespace} from "i18next";
import { useTranslation } from "react-i18next";
import type {$Tuple} from "react-i18next/helpers";

const useIntl = (
  namespace: FlatNamespace | $Tuple<FlatNamespace> | undefined = undefined, keyPrefix?: string
): TFunction => {
  const { t } = useTranslation(namespace, { keyPrefix });

  return t;
};

export default useIntl;
